import type { Position } from '../types';
import { ANIMATION_CONFIG } from '../config';

export const buildPathD = (start: Position, end: Position): string => {
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  const len = Math.max(1, Math.hypot(dx, dy));
  const nx = -dy / len;
  const ny = dx / len;

  const sway = ANIMATION_CONFIG.SWAY_AMOUNT * (0.85 + Math.random() * 0.3);

  const c1x = start.x + dx * ANIMATION_CONFIG.CONTROL_POINT_1 + nx * sway;
  const c1y = start.y + dy * ANIMATION_CONFIG.CONTROL_POINT_1 + ny * sway;
  const c2x =
    start.x + dx * ANIMATION_CONFIG.CONTROL_POINT_2 - nx * (sway * 0.65);
  const c2y =
    start.y + dy * ANIMATION_CONFIG.CONTROL_POINT_2 - ny * (sway * 0.65);

  return `M ${start.x},${start.y} C ${c1x},${c1y} ${c2x},${c2y} ${end.x},${end.y}`;
};

export const setMotionPath = (el: HTMLElement, pathD: string): void => {
  el.style.offsetPath = `path("${pathD}")`;
};

export const setOffsetDistance = (el: HTMLElement, value: string): void => {
  el.style.offsetDistance = value;
};

export const setOffsetRotate = (el: HTMLElement, value: string): void => {
  el.style.offsetRotate = value;
};

export const setOffsetAnchor = (el: HTMLElement, value: string): void => {
  (el.style as any).offsetAnchor = value;
};
